module.exports = __webpack_public_path__ + "static/img/role.865d955.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/jw/role.png
// module id = n/a4
// module chunks = 7